import React, { useCallback, useState } from 'react';

import analytics from 'client/analytics';
import { ANALYTICS_EVENT_UTILITY_PARTNER_TLP_LEARN_MORE_OPENED } from 'client/analytics/eventList';

import UPTenantLiabilityLearnMoreModal from './UPTenantLiabilityLearnMoreModal';

const useTenantLiabilityLearnMoreModal = ({ utilityPartner }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    analytics.track(ANALYTICS_EVENT_UTILITY_PARTNER_TLP_LEARN_MORE_OPENED, {
      utilityPartnerId: utilityPartner?.id ?? null,
      utilityPartnerSlug: utilityPartner?.slug ?? null,
      utilityPartnerName: utilityPartner?.name ?? null,
      utilityPartnerCustomerType: utilityPartner?.customerType ?? null,
    });
    setIsOpen(true);
  }, [utilityPartner]);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const modal = isOpen ? <UPTenantLiabilityLearnMoreModal onClose={close} /> : null;

  return { open, modal };
};

export default useTenantLiabilityLearnMoreModal;
